import { Field } from 'react-final-form';
import Radio from 'components/other/Radio';
import Icon from 'components/other/Icons';

import styles from './TestForm.module.scss';

const ListedTradesKnowledgeField = field => (
  <div className={styles.FieldContainer} tabIndex="0">
    <p>
      Kunnskap om <b>noterte</b> instrumenter:
    </p>
    <Field name="listedTradesKnowledge" type="radio" value="low">
      {({ input }) => (
        <label htmlFor="listedTradesKnowledge_low">
          <Radio
            id="listedTradesKnowledge_low"
            type="radio"
            value={input.value}
            checked={input.checked}
            onChange={input.onChange}
          />
          Ingen
        </label>
      )}
    </Field>
    <Field name="listedTradesKnowledge" type="radio" value="medium">
      {({ input }) => (
        <label htmlFor="listedTradesKnowledge_medium">
          <Radio
            id="listedTradesKnowledge_medium"
            type="radio"
            value={input.value}
            checked={input.checked}
            onChange={input.onChange}
          />
          Middels
        </label>
      )}
    </Field>
    <Field name="listedTradesKnowledge" type="radio" value="high">
      {({ input }) => (
        <label htmlFor="listedTradesKnowledge_high">
          <Radio
            id="listedTradesKnowledge_high"
            type="radio"
            value={input.value}
            checked={input.checked}
            onChange={input.onChange}
          />
          Høy
        </label>
      )}
    </Field>
    {field.meta.error && field.meta.touched && (
      <div className={styles.errorContainer}>
        <Icon icon="exclamation-triangle" />
        <span>{field.meta.error}</span>
      </div>
    )}
  </div>
);

export default ListedTradesKnowledgeField;
